// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__2v6CD","header":"MessagesList_header__2yM8a","chat":"MessagesList_chat__1Wmj_"};